import { createContext, useContext, type ReactNode } from "react";
import type { ApiClient } from "./client";

// ApiClient を React コンポーネントツリーに注入する Context。
// hook 側で createApiClient を直接呼ばないことで、テスト時に baseUrl や
// middleware 構成を差し替え可能にし、複数 hook (useCreatePlayline,
// useAdvanceScene 等) が同一インスタンスを共有できるようにする。
const ApiClientContext = createContext<ApiClient | null>(null);

export type ApiClientProviderProps = {
  client: ApiClient;
  children: ReactNode;
};

export function ApiClientProvider({
  client,
  children,
}: ApiClientProviderProps): JSX.Element {
  return (
    <ApiClientContext.Provider value={client}>
      {children}
    </ApiClientContext.Provider>
  );
}

export function useApiClient(): ApiClient {
  const client = useContext(ApiClientContext);
  if (client === null) {
    // Provider 未配置はテスト/本番いずれでもバグなので早期に検知する。
    throw new Error(
      "useApiClient must be used within an <ApiClientProvider>.",
    );
  }
  return client;
}
